import CitySEOHead from "@/components/feature/CitySEOHead";
import CincinnatiHeroSection from "./components/HeroSection";
import CincinnatiStickyNav from "./components/StickyNav";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityProcessingTimeSection from "@/pages/city-template/components/CityProcessingTimeSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityFAQSection from "@/pages/city-template/components/CityFAQSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { cincinnatiConfig } from "./data";

const areaServedList = [
  { "@type": "City" as const, name: "Cincinnati" },
  { "@type": "City" as const, name: "Covington" },
  { "@type": "City" as const, name: "Newport" },
  { "@type": "City" as const, name: "Florence" },
  { "@type": "City" as const, name: "Erlanger" },
  { "@type": "City" as const, name: "Fairfield" },
  { "@type": "City" as const, name: "Mason" },
  { "@type": "City" as const, name: "West Chester" },
  { "@type": "City" as const, name: "Blue Ash" },
  { "@type": "City" as const, name: "Loveland" },
  { "@type": "City" as const, name: "Milford" },
  { "@type": "City" as const, name: "Norwood" },
  { "@type": "AdministrativeArea" as const, name: "Hamilton County" },
  { "@type": "AdministrativeArea" as const, name: "Butler County" },
  { "@type": "AdministrativeArea" as const, name: "Campbell County" },
  { "@type": "AdministrativeArea" as const, name: "Kenton County" },
];

export default function CincinnatiPage() {
  return (
    <>
      <CitySEOHead
        city="Cincinnati"
        state="Ohio"
        stateAbbr="OH"
        route="/cities/cincinnati"
        title="Emergency Passport Cincinnati, OH — Expedited & 24-Hour Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Cincinnati, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier at 312 Walnut St serving Hamilton County and the Greater Cincinnati tri-state area including Northern Kentucky."
        ogTitle="Emergency Passport Cincinnati, OH — Expedited & 24-Hour Fast Passport Service | Fast Passport Center"
        ogDescription="Emergency and expedited passport services in Cincinnati, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier at 312 Walnut St serving Hamilton County and the Greater Cincinnati tri-state area including Northern Kentucky."
        twitterTitle="Emergency Passport Cincinnati, OH — Expedited & 24-Hour Fast Passport Service | Fast Passport Center"
        twitterDescription="Emergency and expedited passport services in Cincinnati, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier at 312 Walnut St serving Hamilton County and the Greater Cincinnati tri-state area including Northern Kentucky."
        geoPlacename="Cincinnati, Ohio"
        geoPosition="39.1031;-84.5120"
        keywords="expedited passport Cincinnati, emergency passport Cincinnati OH, same day passport Cincinnati, fast passport Hamilton County, passport renewal Cincinnati, 312 Walnut St passport office, CVG airport passport, Northern Kentucky passport, Cincinnati passport courier"
        faqs={cincinnatiConfig.faqs}
        servicesSchema={cincinnatiConfig.servicesSchema}
        statePageName="Ohio"
        statePageRoute="/states/ohio"
        hasPhysicalOffice
        lastModified="2026-07-18"
        ogImage="https://readdy.ai/api/search-image?query=Cincinnati%20Ohio%20downtown%20skyline%20panorama%20with%20the%20iconic%20Roebling%20Suspension%20Bridge%20over%20the%20Ohio%20River%20at%20golden%20hour%2C%20modern%20glass%20office%20towers%20and%20historic%20architecture%2C%20warm%20amber%20sunset%20light%2C%20professional%20cityscape%20photography%20with%20rich%20colors%20and%20clear%20sky&width=1200&height=630&seq=cincinnati-og-2026&orientation=landscape"
        areaServedList={areaServedList}
        serviceAreaDesc="Fast Passport Center is a registered U.S. Department of State passport courier serving Cincinnati, Hamilton County, Northern Kentucky, and the Greater Cincinnati tri-state area with expedited passport processing as fast as 24 hours. A+ BBB rated. Located at 312 Walnut St, Cincinnati, OH 45202 near Fountain Square."
      />
      <div className="font-sans">
        <CincinnatiHeroSection />
        <CincinnatiStickyNav />
        <CityLocalAreaSection
          city={cincinnatiConfig.city}
          state={cincinnatiConfig.state}
          cities={cincinnatiConfig.nearbyCitiesZips}
          benefits={cincinnatiConfig.benefits}
          internalLinks={cincinnatiConfig.internalLinks}
          officeNote={cincinnatiConfig.fpcOfficeNote}
          officeDistance={cincinnatiConfig.fpcOfficeDistance}
          officeAddress={cincinnatiConfig.fpcOfficeAddress}
          serviceAreaIntro={cincinnatiConfig.serviceAreaIntro}
          nearbyCitiesIntro={cincinnatiConfig.nearbyCitiesIntro}
          mapEmbedUrl={cincinnatiConfig.mapEmbedUrl}
          officePhone={cincinnatiConfig.officePhone}
          officeHours={cincinnatiConfig.officeHours}
          officePhotoUrl={cincinnatiConfig.officePhotoUrl}
          officePhotoAlt={cincinnatiConfig.officePhotoAlt}
          landmarks={cincinnatiConfig.landmarks}
        />
        <CityProcessingTimeSection
          city={cincinnatiConfig.city}
          state={cincinnatiConfig.state}
          options={cincinnatiConfig.processingOptions}
          regionalAgency={cincinnatiConfig.regionalAgency}
        />
        <CityServicesSection
          city={cincinnatiConfig.city}
        />
        <CityTestimonialsSection
          city={cincinnatiConfig.city}
          testimonials={cincinnatiConfig.testimonials}
          intro={cincinnatiConfig.testimonialsIntro}
        />
        <CityAcceptanceFacilitiesSection
          city={cincinnatiConfig.city}
          facilities={cincinnatiConfig.facilities}
        />
        <CityComparisonSection
          city={cincinnatiConfig.city}
          regionalAgency={cincinnatiConfig.regionalAgency}
          rows={cincinnatiConfig.comparisonRows}
        />
        <CityMistakesSection
          city={cincinnatiConfig.city}
          mistakes={cincinnatiConfig.mistakes}
          intro={cincinnatiConfig.mistakesIntro}
        />
        <CityHowItWorksSection
          city={cincinnatiConfig.city}
          steps={cincinnatiConfig.steps}
          intro={cincinnatiConfig.howItWorksIntro}
        />
        <CityFAQSection
          city={cincinnatiConfig.city}
          faqs={cincinnatiConfig.faqs}
          intro={cincinnatiConfig.faqIntro}
        />
        <CityHelpfulResourcesSection
          city={cincinnatiConfig.city}
          state={cincinnatiConfig.state}
          photoLocations={cincinnatiConfig.photoLocations}
          dmvLocations={cincinnatiConfig.dmvLocations}
          airports={cincinnatiConfig.airports}
          dmvWebsite={cincinnatiConfig.dmvWebsite}
          dmvLabel={cincinnatiConfig.dmvLabel}
          vitalRecordsLinks={cincinnatiConfig.vitalRecordsLinks}
        />
        <SEOCrossLinks currentRoute="/cities/cincinnati" state="OH" />
        <CityFinalCTA />
      </div>
    </>
  );
}